<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 45 32"
  >
    <g
      :fill="color"
      class="fill-current"
    >
      <path d="M44.743 6.796c-0.302-1.704-0.895-3.225-1.73-4.58l0.032 0.056c-1.226-1.066-2.78-1.784-4.493-1.985l-0.039-0.004c-6.23-0.283-15.858-0.283-15.858-0.283v0s-9.629 0-15.858 0.566c-0.084-0.005-0.182-0.007-0.281-0.007-1.702 0-3.224 0.77-4.236 1.981l-0.007 0.009c-1.416 1.133-1.699 4.241-1.699 4.241-0.336 2.192-0.543 4.743-0.572 7.336l-0 0.032v3.399c0.028 2.622 0.233 5.171 0.604 7.666l-0.037-0.304c0.304 1.707 0.899 3.229 1.738 4.586l-0.032-0.056c1.389 1.131 3.148 1.859 5.071 1.981l0.026 0.001c3.399 0.283 15.298 0.566 15.298 0.566s9.629 0 15.858-0.566c0.086 0.005 0.186 0.007 0.287 0.007 1.702 0 3.224-0.77 4.236-1.981l0.007-0.009c0.939-1.26 1.554-2.812 1.697-4.498l0.002-0.033c0.334-2.191 0.539-4.741 0.566-7.332l0-0.030v-3.399c-0.028-2.622-0.233-5.171-0.604-7.666l0.037 0.304zM17.841 21.811v-12.749l12.176 6.513-12.176 6.236z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
